<div class="digital-asset-complexity-calculator d-flex">
  <div class="complexity-calculator-inputs d-flex align-items-end gap-2">
    <div class="input-wrapper">
      <ds-input
        [label]="'digital_properties' | translate"
        [showRequiredAsterisk]="false"
        [attr.data-test-id]="controlName() + '_total'"
      >
        <input
          ds-input-field
          type="number"
          [min]="minInputValue"
          [max]="maxInputValue"
          [value]="totalSignal()"
          (input)="onTotalChange($any($event.target))"
          [attr.aria-label]="'digital_properties' | translate"
          [attr.aria-describedby]="bannerState() ? 'dpComplexityCounts-error' : null"
        />
      </ds-input>
      <div class="input-sublabel">{{ 'label_total' | translate }}</div>
    </div>

    <div class="calculator-icon">
      <ds-icon [icon]="Icons.Equals" iconStyle="fas" aria-hidden="true"></ds-icon>
    </div>

    <div class="input-wrapper">
      <ds-input [label]="''" [showRequiredAsterisk]="false" [attr.data-test-id]="controlName() + '_high'">
        <input
          ds-input-field
          type="number"
          [min]="minInputValue"
          [max]="maxInputValue"
          [value]="highSignal()"
          (input)="onHighChange($any($event.target))"
          [attr.aria-label]="'label_high_complexity_assets' | translate"
        />
      </ds-input>
      <div class="input-sublabel">{{ 'label_high_complexity_assets' | translate }}</div>
    </div>

    <div class="calculator-icon">
      <ds-icon [icon]="Icons.Plus" iconStyle="fas" aria-hidden="true"></ds-icon>
    </div>

    <div class="input-wrapper">
      <ds-input [label]="''" [showRequiredAsterisk]="false" [attr.data-test-id]="controlName() + '_medium'">
        <input
          ds-input-field
          type="number"
          [min]="minInputValue"
          [max]="maxInputValue"
          [value]="mediumSignal()"
          (input)="onMediumChange($any($event.target))"
          [attr.aria-label]="'label_medium_complexity_assets' | translate"
        />
      </ds-input>
      <div class="input-sublabel">{{ 'label_medium_complexity_assets' | translate }}</div>
    </div>

    <div class="calculator-icon">
      <ds-icon [icon]="Icons.Plus" iconStyle="fas" aria-hidden="true"></ds-icon>
    </div>

    <div class="input-wrapper">
      <ds-input [label]="''" [showRequiredAsterisk]="false" [attr.data-test-id]="controlName() + '_low'">
        <input
          ds-input-field
          type="number"
          [min]="minInputValue"
          [max]="maxInputValue"
          [value]="lowSignal()"
          (input)="onLowChange($any($event.target))"
          [attr.aria-label]="'label_low_complexity_assets' | translate"
        />
      </ds-input>
      <div class="input-sublabel">{{ 'label_low_complexity_assets' | translate }}</div>
    </div>
  </div>

  @if (bannerState()) {
    <div class="banner-wrapper">
      <div class="ds-input-error-message" id="dpComplexityCounts-error" tabindex="-1" aria-hidden="true">
        <ds-banner [state]="bannerState()">
          <div ds-banner-body>
            {{ bannerMessage() }}
          </div>
        </ds-banner>
      </div>
    </div>
  }
</div>
